import { BatchItemHistory } from './batchItemHistory';

export class BatchGroup{

    label: string;
    value: string;
    items : BatchItemHistory[] =[];
}